<template>
  <div>
    <CCard
      class="defaultCard mr-2"
      @click="onAction"
      @mouseover="data.active = true"
      @mouseleave="data.active = false"
      v-if="data.status === true"
    >
      <CCardHeader class="defaultHeaderCard">
        <CRow>
          <CCol class="text-left" xl="12">
            <div class="header-card">
              <p class="titleText">บทที่ {{ this.index }}</p>
              <div class="icon">
                <i v-if="progress >= 100" class="fas fa-check-circle"></i>
                <i v-else class="fas fa-circle inactive"></i>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody class="column p-0">
        <div class="card-body pt-0 pb-0">
          <div>
            <CRow>
              <CCol
                sm="12"
                v-c-tooltip="$helpers.translate(courseDetail.description, 'th')"
                class="text-left font-weight-bolder fullName truncateCourseName"
                style="color: #999999"
                >{{ $helpers.translate(courseDetail.description, "th") }}</CCol
              >
            </CRow>
            <CRow class="mt-2">
              <CCol sm="4" class="text-left description" style="color: #999999"
                >Score</CCol
              >
              <CCol
                v-if="progress !== undefined"
                sm="8"
                class="text-right description"
                style="color: #999999"
                >{{ courseDetail.score.toFixed(1) }}/100</CCol
              >
              <CCol
                v-else
                sm="8"
                class="text-right description"
                style="color: #999999"
                >00/100</CCol
              >
            </CRow>
            <CRow>
              <CCol
                md="8"
                sm="5"
                class="text-left description"
                style="color: #999999"
                >Active Min</CCol
              >
              <CCol
                v-if="progress !== undefined"
                md="4"
                sm="7"
                class="text-right truncateCatefory"
                style="color: #999999"
                >{{ this.$helpers.getUsetimeInMin(courseDetail.usetime) }}</CCol
              >
              <CCol
                v-else
                md="4"
                sm="7"
                class="text-right truncateCatefory"
                style="color: #999999"
                >0.00</CCol
              >
            </CRow>

            <br />
          </div>
        </div>

        <CRow class="card-body pt-0" @click="navigateOverview(data)">
          <CCol @click="onclickProgressBarButton('progressbar')">
            <CButton
              block
              class="border-0 button-overview-notActive"
              v-if="progress == 0"
              >NO PROGRESS</CButton
            >
            <CButton
              block
              class="border-0 button-overview"
              v-else-if="progress >= 100"
              >COMPLETE</CButton
            >
            <CProgress
              class="progress-bar"
              showPercentage
              :value="returnProgress(progress)"
              :max="100"
              show-value
              border-radius="50px"
              v-else-if="progress > 1 && progress < 100"
            >
              <CProgressBar
                style="border-radius: 20px; background-color: #62ce62"
                >{{ progress.toFixed(1) }}%</CProgressBar
              >
            </CProgress>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    courseDetail: Object,
    progress: Number,
    index: Number,
    courseCodeIdParams: String,
    link: String,
  },
  data() {
    return {
      isComplete: true,
      lang: "th",
    };
  },
  created() {
    this.isComplete = this.courseDetail.topic.topicUsers[0].complete;
  },
  methods: {
    onAction() {
      this.$router.push(this.link);
    },
    navigateOverview(nav) {
      if (this.progress.progress < 1) {
      } else {
        if (this.courseCodeIdParams == "24081001") {
          this.$router.push("/HP01/1");
        } else if (this.courseCodeIdParams == "1901309") {
          this.$router.push("/CPRmenu");
        } else if (this.courseCodeIdParams == "1901319") {
          this.$router.push("/CPRmenu");
        }
      }
    },
    returnProgress(val) {
      if (val <= 30) {
        let newVal = 30;
        return newVal;
      } else {
        return val;
      }
    },
  },
  watch: {},
  mounted() {
  },
};
</script>

<style scoped>
.defaultCard {
  position: relative;
  max-height: 100%;
  width: 210px;
  border-radius: 30px;
  background-color: #4d4d4d;
}

.defaultCard:hover {
  /*background-color: red;*/
  cursor: pointer;
}

.defaultHeaderCard {
  padding: 0rem 1.25rem;
  border: 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: transparent;
}

.defaultHeaderCard .titleText {
  font-size: 36px;
  font-weight: bold;
  color: #999999;
  margin-bottom: 0;
  margin-top: 0.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-body {
  -ms-flex: 1 1 auto;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  min-height: 1px;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.icon {
  font-size: 30px;
  color: #62ce62;
}

.icon .inactive {
  color: #999999;
}

.header-card {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.description {
  font-size: 14px;
}

.button-overview {
  color: white;
  background-color: #62ce62;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 1px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}
.button-overview-notActive {
  color: #4d4d4d;
  background-color: #999999;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 1px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.progress-bar {
  width: 100%;
  height: 100%;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
  background: white;
}

.truncateCourseName {
  width: 5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;

  font-size: 1.12rem;
  margin-bottom: 0.1rem;
  /*allow user to add more space for word*/
  /*resize: horizontal;*/
}

.truncateCatefory {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 0.9rem;
  /*allow user to add more space for word*/
  /*resize: horizontal;*/
}
</style>

